import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('serviceIntervalsModalPlaceholder');

    return {
        NO_ASSETS: t('noAssets')
    };
};

export default useTranslation;
